import { defineStore } from 'pinia';

export const useGlobalStore = defineStore('global', {
    state: () => ({
        isDataLoaded: false,
        heroVideoReady: false,
    }),
    actions: {
        fetchData() {
            // Images are now lazy-loaded via native loading="lazy" attributes
            // No eager preloading needed - let the browser handle it
            this.isDataLoaded = true;
        },
        loadImage(src) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => resolve(src);
                img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
                img.src = src;
            });
        }
    }
});
